import AbstractScene from './AbstractScene.js';
import ButtonArrow from '../prefabs/buttons/ButtonArrow.js';
import LevelBtn from '../prefabs/LevelBtn.js';

export default class KaraokeEnd extends AbstractScene {
    constructor() {
        super({
            key: "KaraokeEnd"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
    }


    // update(){

    // }

    create() {
        this.background = this.add.image(0, 0, 'endBackgroundCredits').setOrigin(0, 0);

        this.logo = this.add.image(50, -82, 'logoNovotelWwf').setOrigin(0);

        this.tweens.add({
            targets: this.logo,
            duration: 500,
            ease: 'Cubic.easeInOut',
            y: -1,
        });

        this.btn = new ButtonArrow(this, this.width/2, 960, 348, 56, "Terminer l’expérience", "24px")
        this.btn.setClickFunction(() => {
            this.scene.start('Intro');
        });
    }


}
